import * as React from 'react';
import { useCallback, useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import { Routes } from '../../routes';
import { PageHeadingWidget } from '../../widgets/page/PageHeadingWidget';
import { ProfilePageWidget } from '../../widgets/page/ProfilePageWidget';
import { useSystem } from '../../hooks/useSystem';
import { styled } from '../../theme';
import { ENV } from '../../env';
import { SerializedTokenWithoutValueResource } from '@journeyapps-platform/types-cardinal';
import { ButtonType, ButtonWidget } from '../../widgets/buttons/ButtonWidget';
import { SearchableTableWidget } from '../../widgets/table/SearchableTableWidget';
import { DateTime } from 'luxon';

export const ProfileTokensPage: React.FC = observer(() => {
  const system = useSystem();
  const { cardinalClient } = system;
  const [tokens, setTokens] = useState<SerializedTokenWithoutValueResource[]>([]);

  const loadLoadTokens = useCallback(async () => {
    const tokensRes = cardinalClient.listTokens.paginate({
      user_id: ENV.USER_ID,
      org_id: ENV.USER_ORG
    });
    for await (let page of tokensRes) {
      setTokens([...tokens, ...page.items]);
    }
  }, []);

  useEffect(() => {
    loadLoadTokens();
  }, []);

  return (
    <ProfilePageWidget activeItemKey={Routes.PROFILE_TOKENS}>
      <S.Container>
        <PageHeadingWidget title={'Access Tokens'} />
        <SearchableTableWidget
          columns={[
            {
              display: 'Label',
              key: 'label'
            },
            {
              display: 'Created at',
              key: 'created_at',
              noWrap: true,
              shrink: true,
              accessor: ({ cell }) => {
                let date = DateTime.fromISO(cell);
                return date.toLocaleString();
              }
            },
            {
              display: 'Revoke',
              key: 'shrink',
              shrink: true,
              accessor: ({ row }) => {
                return (
                  <ButtonWidget
                    icon={'ban'}
                    label="Revoke"
                    type={ButtonType.TERTIARY}
                    action={async (event2, loading) => {
                      const revoke = await system.dialogStore.confirmDialog({
                        title: 'Revoke token?',
                        message: 'This action cannot be undone.'
                      });
                      if (!revoke) {
                        return;
                      }

                      loading(true);
                      await cardinalClient.deleteToken({
                        id: row.key
                      });
                      loadLoadTokens();
                    }}
                  />
                );
              }
            }
          ]}
          rows={tokens.map((t) => {
            return {
              key: t.id,
              cells: {
                label: t.description,
                created_at: t.created_at
              }
            };
          })}
        />
      </S.Container>
    </ProfilePageWidget>
  );
});

namespace S {
  export const Container = styled.div`
    margin: auto;
    margin-bottom: 20px;
    width: 900px;
  `;
}
